<div class="supplier-search-component-wrapper" (click)="showFilterMenu=== true? showFilterMenu = false : null">
  @if (isModal) {
    <div class="modal-header">
      <div class="modal-toolbar">
        <div>
          <div class="modal-title">{{ title }}</div>
          <div class="modal-title">
            <app-display-icon (click)="close()" [icon]="icons.close"></app-display-icon>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="grid" [ngClass]="{'grid-container' : isModal}">
    <div class="search-or-preview">
      @if (!preview) {
        <div class="search-input-container">
          <app-shared-custom-search
            [searchAll]="searchString"
            [placeholder]="'Search Suppliers'"
            (searchChange)="searchOnKeyUp($event)">
          </app-shared-custom-search>
        </div>
        <ng-content select="[slot=toggles]"></ng-content>
      } @if (preview) {
      <h1>
        Selected Suppliers
      </h1>
    } @if (isEditSchedule) {
      <div class="filter-menu">
        <div class="filter-row">
          <label [matTooltip]="'Show supplier that are in the schedule'">Scheduled</label>
          <app-switch-ui
            (checkedChange)="suppDisMod.filter.assigned = $event; filterSupp()"
            [checked]="suppDisMod.filter.assigned"
            [size]="0.7">
          </app-switch-ui>
        </div>
        <div class="filter-row">
          <label [matTooltip]="'Show supplier that are not in the schedule'">Unscheduled</label>
          <app-switch-ui
            (checkedChange)="suppDisMod.filter.unassigned = $event; filterSupp()"
            [checked]="suppDisMod.filter.unassigned"
            [size]="0.7">
          </app-switch-ui>
        </div>
        <div class="filter-row">
          <label [matTooltip]="'Hide Supplier with no stock items'">Hide No Stock Items</label>
          <app-switch-ui
            (checkedChange)="hideNoItems = $event; filterSupp()"
            [checked]="hideNoItems"
            [size]="0.7">
          </app-switch-ui>
        </div>
        <div class="filter-row">
          <label [matTooltip]="'Hide suppliers that are on hold'">Hide On Hold</label>
          <app-switch-ui
            (checkedChange)="dontSowDisabled = $event; filterSupp()"
            [checked]="dontSowDisabled"
            [size]="0.7">
          </app-switch-ui>
        </div>
      </div>
    } @if (isEditSchedule) {
      <div class="visible-fields-selector">
        <app-shared-visible-fields
          #visibleFields
          [setGridColDefs]="gridColDefs"
          [setDefaultGridColDefs]="defaultColDefs"
          (emitSelectedFields)="onVisibleFieldsChange($event)"
          [localStorageOrderKey]="localStorageEnum.agGridColDefOrderAddSupplier"
          [localStorageSizeKey]="localStorageEnum.agGridColDefSizeAddSupplier">
        </app-shared-visible-fields>
      </div>
    }

    </div>

    <div [ngClass]="isModal? 'modal-grid-div' : 'grid-div'">
      <ag-grid-angular
        (gridReady)="onGridReady($event)"
        (gridSizeChanged)="onGridSizeChange()"
        [columnDefs]="gridColDefs"
        [columnTypes]="columnTypes"
        [defaultColDef]="generalColDefDefaults"
        [gridOptions]="getGridOptions"
        [overlayNoRowsTemplate]="overlayTemplate"
        [rowData]="fuzzySuppliers"
        [theme]="'legacy'"
        class="ag-theme-custom">
      </ag-grid-angular>
    </div>

    <ng-container>
      @if (isModal) {
        <div class="buttons-div">
          <app-shared-button (buttonClicked)="onViewSelectedClick()" [disabled]="selectedStockItemCount < 1 && !preview"
                             [fill]="false">
            {{ getPreviewButtonData }}
          </app-shared-button>
          <app-shared-button (buttonClicked)="onGetSelectedStockItemsClick()" [disabled]="selectedStockItemCount < 1"
                             [fill]="false">
            Add {{ selectedStockItemCount !== 1 ? selectedStockItemCount + ' Suppliers' : selectedStockItemCount + ' Supplier' }}
          </app-shared-button>
        </div>
      } @else {
      <div class="not-modal-buttons-div">
        @if (isEditSchedule) {
          <app-shared-button (buttonClicked)="onCancelClick()" class="cancel-button">
            Cancel
          </app-shared-button>
        } @if (selectAll) {
        <app-shared-button
          (buttonClicked)="onSelectAllSuppliersClick(selectedStockItemsMap.size >= selectedSuppliers.length)"
          [fill]="false">
          {{ selectedStockItemsMap.size >= selectedSuppliers.length ? 'UnSelect All' : 'Select All' }}
        </app-shared-button>
      }
        <app-shared-button (buttonClicked)="onViewSelectedClick()" [disabled]="selectedStockItemCount < 1 && !preview"
                           [fill]="false">
          {{ getPreviewButtonData }}
        </app-shared-button>
        <app-shared-button (buttonClicked)="onGetSelectedStockItemsClick()" [disabled]="selectedStockItemCount < 1"
                           [fill]="false">
          {{ acceptButtonText[0] }} {{ selectedStockItemCount !== 1 ? selectedStockItemCount + ' ' + acceptButtonText[1] : selectedStockItemCount + ' ' + acceptButtonText[2] }}
        </app-shared-button>
      </div>
    }

    </ng-container>

  </div>

</div>
